import { SLOT_BECAME_EMPTY, } from 'actiontypes/myself';

import { AREA_CHANGE_MESSAGE, SETTING_CHANGE_MESSAGE } from 'constants/messageTypes';

import { processFateChange } from 'actions/fate';

import { fetchMyself } from 'actions/myself';
import { fetch as fetchMap, setCurrentArea, setMapShouldUpdate, } from 'actions/map';
import { fetchPlans } from 'actions/plans';
import { shouldFetch as setOpportunitiesShouldFetch } from 'actions/cards'
import { IAppState } from "types/app";
import { IHasTypeString, IMessages, IStandardMessage } from 'types/app/messages';

import findEquippedItemLosses from './equippedItemLosses';
import isAreaUnlockMessage from './isAreaUnlockMessage';
import mapShouldUpdate from './mapShouldUpdate';
import plansShouldUpdate from './plansShouldUpdate';
import opportunitiesShouldFetch from './opportunitiesShouldFetch';
import processStandardMessages from './processStandardMessages';
import qualitiesMayHaveChanged from './qualitiesMayHaveChanged';
import getQualitiesRequiredAllPlans from '../../../selectors/plans/getQualitiesRequiredAllPlans';

import getQualityRequirementsAllCards from '../../../selectors/cards/getQualitiesRequiredAllCards';
import processSettingChangeMessage from 'actions/app/processMessages/processSettingChangeMessage';


/** ----------------------------------------------------------------------------
 * PROCESS MESSAGES
 -----------------------------------------------------------------------------*/

/**
 *
 * @param messages
 * @param ignoredMessageTypes We ignore these during processing.
 */
export default function processMessages(messages: IMessages, ignoredMessageTypes: string[] = []) {
  return (dispatch: Function, getState: () => IAppState) => {

    if (!messages) {
      return;
    }

    try {
      const {
        areaMessage,
        defaultMessages = [],
        standardMessages = [],
      } = messages;

      const { plans, cards: { displayCards } }: IAppState = getState();

      if (messages.fateMessage) {
        dispatch(processFateChange(messages.fateMessage.currencyChangeAmount));
      }

      // setting change (should only ever be 1, which may be ignored by gate event handling)
      defaultMessages
        .filter(({ type }) => !ignoredMessageTypes.includes(type))
        .filter(({ type }) => type === SETTING_CHANGE_MESSAGE)
        .forEach((message) => dispatch(processSettingChangeMessage(message)));

      // Update plans
      if (plansShouldUpdate(messages, getQualitiesRequiredAllPlans(plans))) {
        dispatch(fetchPlans());
      }

      // If one of the messages involves an area unlocking quality, or we have changed Setting
      // then fetch // (if we are not already fetching)
      const isMapFetching = (getState().map || { isFetching: false }).isFetching;
      const areaHasBeenUnlocked = standardMessages.find(isAreaUnlockMessage);
      const settingHasChanged = defaultMessages.find(({ type }) => type === SETTING_CHANGE_MESSAGE);
      const mapNeedsUpdate = areaHasBeenUnlocked || settingHasChanged;
      if (!isMapFetching && mapNeedsUpdate) {
        dispatch(fetchMap());
      }

      // Area messages
      if (areaMessage && !ignoredMessageTypes.includes(AREA_CHANGE_MESSAGE)) {
        dispatch(setCurrentArea(areaMessage.area));
      }

      // Is the character losing any equipped items?
      const equippedItemLosses = findEquippedItemLosses(standardMessages, getState());
      equippedItemLosses
        .filter(({ type }: IHasTypeString) => !ignoredMessageTypes.includes(type))
        .forEach(({ category, possession }: IStandardMessage) => {
          dispatch({ type: SLOT_BECAME_EMPTY, payload: { category, possession } });
        });

      // If the character has lost an equipped item, then it's likely that their
      // modified qualities have changed
      if (equippedItemLosses.length) {
        // TODO: do we need a full fetch here?
        dispatch(fetchMyself());
      }

      // Should map update?
      if (mapShouldUpdate(messages)) {
        if (messages.defaultMessages
          .filter(({ type }: IHasTypeString) => !ignoredMessageTypes.includes(type))
          .some(({ type }: IHasTypeString) => type === 'MapShouldUpdateMessage')) {
          dispatch(fetchMap());
        } else {
          dispatch(setMapShouldUpdate(true));
        }
      }

      if (opportunitiesShouldFetch(messages, getQualityRequirementsAllCards(displayCards))) {
        dispatch(setOpportunitiesShouldFetch())
      }

      // have qualities changed? This is quite a coarse-grained check
      // that will re-fetch both myself and possessions
      if (qualitiesMayHaveChanged(messages)) {
        dispatch(processStandardMessages(standardMessages));
      }
    } catch (error) {
      console.error(error);
    }
  };
}